// Chilean Peso formatter: $ 1.500.000
export function fmtCLP(amount, { showSign = false, dim = false } = {}) {
  if (amount == null || isNaN(amount)) return "—";
  const n = Math.round(Number(amount));
  const abs = Math.abs(n).toLocaleString("es-CL");
  const sign = n < 0 ? "-" : showSign && n > 0 ? "+" : "";
  return `${sign}$ ${abs}`;
}

export function fmtNum(amount) {
  if (amount == null || isNaN(amount)) return "—";
  return Math.round(Number(amount)).toLocaleString("es-CL");
}

export function fmtDate(iso) {
  if (!iso) return "";
  // "YYYY-MM-DD" se interpreta como medianoche UTC: en Chile mostraría el día anterior.
  const solo = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso));
  if (solo) return `${solo[3]}-${solo[2]}-${solo[1]}`;
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return String(iso);
    return d.toLocaleDateString("es-CL", { year: "numeric", month: "2-digit", day: "2-digit" });
  } catch {
    return iso;
  }
}

export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function currentMonthISO() {
  return todayISO().slice(0, 7);
}
